import { apiGet, apiPost } from '../../generic/Api_Functions'
import { toParams } from '../model/timelineQuery'

// Adapters of the endpoints the screen consumes (03-dominio.md §«Repositorios necesarios»). Every call goes through
// Api_Functions, whose paths are appended to `/endpoints/`.

/** GET dataCorrection/timeline for the screen's query (#189). */
export const getTimeline = (query) => apiGet('dataCorrection/timeline', toParams(query))

/**
 * GET dataCorrection/timeline for the «before» tape of a preview (RN61, A202-5). It is NOT the screen's query: `from` and `to`
 * are the texts of `timelineAfter.range` exactly as Sun wrote them (milliseconds included, up to 31 days), so it does not go
 * through TimelineQuery and nothing here shortens it.
 */
export const getTimelineBefore = (deviceId, workerId, range) =>
  apiGet('dataCorrection/timeline', { deviceId, workerId, from: range.from, to: range.to })

/** GET dataCorrection/reasons, only the ones that can be applied (#189). */
export const getReasons = () => apiGet('dataCorrection/reasons', { appliesTo: 'APPLY' })

/** GET devicesBasicData: `{id, name}` of the active, non external machines (no permission needed, RN21 bis). */
export const getDeviceCatalog = () => apiGet('devicesBasicData')

/** GET allWorkersSimple: `{id, code, name}` of the active workers (WORKERS or MOS permission, RN21 bis). */
export const getWorkerCatalog = () => apiGet('allWorkersSimple')

/** POST dataCorrection/preview (#201): the rehearsal. The signal is only used to abort when the panel closes (RN57). */
export const previewCorrection = (intent, signal) => apiPost('dataCorrection/preview', intent, {}, signal)

/** POST dataCorrection (#201): apply exactly the previewed intent with its plan hash (RN66). */
export const applyCorrection = (body) => apiPost('dataCorrection', body)

/** GET dataCorrection/reasons of both phases: the history names the reasons of applying AND of reverting (#189 RN49). */
export const getAllReasons = () => apiGet('dataCorrection/reasons')

/** POST dataCorrection/search (#207): a page of the correction history; `{}` is page 0 of 20 without filters. */
export const searchCorrections = (body) => apiPost('dataCorrection/search', body)

/** GET dataCorrection/{id} (#205): the detail of one correction, without the row images. */
export const getCorrection = (id) => apiGet(`dataCorrection/${id}`)

/** POST dataCorrection/{id}/revert (#203, #210 C3): `{reasonCode, comment, cascade}`; 200 with one or two headers. */
export const revertCorrection = (id, body) => apiPost(`dataCorrection/${id}/revert`, body)

/** GET dataCorrection/reasons of reverting (#203 §8.3): Sun answers the REVERT and the BOTH ones. */
export const getRevertReasons = () => apiGet('dataCorrection/reasons', { appliesTo: 'REVERT' })
